import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=4a6909a7&scoped=true"
import script from "./Limits.vue?vue&type=script&lang=js"
export * from "./Limits.vue?vue&type=script&lang=js"
import style0 from "./Limits.vue?vue&type=style&index=0&id=4a6909a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6909a7",
  null
  
)

export default component.exports